const _ = require('lodash');

const SearchPhraseActionService = function SearchPhraseActionService(Restangular, $state, loginService, shopperService, $window, moveFocus, $q, bootstrap, searchMultisearchService, searchService) {
    this._api = Restangular.one('Search');
    this._state = $state;
    this._window = $window;
    this._q = $q;
    this.loginService = loginService;
    this.shopper = shopperService;
    this.multisearchService = searchMultisearchService;
    this.searchService = searchService;
    this._moveFocus = moveFocus;

    this.action = {
        login: 'PromptLogin',
        navigate: 'GoToUrl'
};

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SearchPhraseActions)) {
        this._setSearchPhraseActions.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.SearchPhraseActions));
    }
};

SearchPhraseActionService.prototype._setSearchPhraseActions = function (searchPhraseActions) {
    this.searchPhraseActions = _.keyBy(searchPhraseActions.SearchPhraseActions, function (searchPhraseAction) {
        return searchPhraseAction.Phrase;
    });
};

SearchPhraseActionService.prototype.getSearchPhraseAction = function (searchTerm) {
    const deferred = this._q.defer();

    if (this.searchPhraseActions) {
        deferred.resolve(searchTerm in this.searchPhraseActions && this.searchPhraseActions[searchTerm]);
        return deferred.promise;
    }

    return this._api.one('SearchPhraseAction').get({
        SearchTerm: searchTerm
    });
};

SearchPhraseActionService.prototype.actionPromptsForLogin = function (searchPhraseAction) {
    return searchPhraseAction.Action === this.action.login && this.shopper.currentUser.isGuest;
};

SearchPhraseActionService.prototype.performSearchPhraseAction = function (searchPhraseAction, openNewTab, redirectUnsuccessfulLoginToHomepage) {
    const self = this;
    return this._q(function (resolve, reject) {
        if (self.actionPromptsForLogin(searchPhraseAction)) {
            self._moveFocus('#loginForm-Email');
            return self.loginService.promptForLogin(self.loginService.LoginToContinueMessage)
                .then(resolve)
            .catch(function () {
                if (redirectUnsuccessfulLoginToHomepage) {
                    // If the user gets a 401 and doesn't log in, redirect to home page.
                    self._window.location.href = '/';
                }
            });
        } else if (searchPhraseAction.Action === self.action.navigate) {
            if (searchPhraseAction.Target === 'Blank') {
                self.searchService.verifyAndReset('external', searchPhraseAction.Phrase);
                self._state.go('shop.search.external-result', { searchTerm: searchPhraseAction.Phrase, multisearchItems: undefined });
                if (openNewTab) {
                    self._window.open(searchPhraseAction.URL, '_blank');
                }
            } else {
                self._window.location.href = searchPhraseAction.URL;
            }
            return reject();
        }
        return resolve();
    });
};

SearchPhraseActionService.prototype.searchRequiresLogin = function (searchPhrase) {
    const self = this;
    return this._q(function (resolve) {
        if (!searchPhrase || searchPhrase === '') {
            resolve(false);
        }
        self.getSearchPhraseAction(searchPhrase).then(function (action) {
            if (action) {
                resolve(self.actionPromptsForLogin(action) && !self.multisearchService.isSearchMultisearch());
            }
            resolve(false);
        });
    });
};

module.exports = SearchPhraseActionService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-phrase-action-service.js
 **/